const postsInitialState = []




export default postsInitialState;